import { Permission, permissionFromDto, PermissionJson } from './permission'

declare const RoleIDSymbol: unique symbol
export type RoleID = string & { [RoleIDSymbol]: never }

export interface RoleJson {
    id: string
    name: string
    permissions?: { data: PermissionJson[] }
}

export interface Role {
    id: RoleID
    name: string
    permissions: readonly Permission[]
}

export const createRole = (
    params: {
        id: RoleID
        name: string
        permissions: Permission[]
    }
): Role => ({
    id: params.id,
    name: params.name,
    permissions: params.permissions,
})

export const roleFromDto = (dto: RoleJson): Role => (createRole({
    id: dto.id as RoleID,
    name: dto.name,
    permissions: dto.permissions?.data ? dto.permissions.data.map((permissionDto: PermissionJson) => permissionFromDto(permissionDto)) : [],
}))
